export const GET_DESTINOS_LOADING = "get/destinos/loading"
export const GET_DESTINOS_SUCCESS = "get/destinos/success"
export const GET_DESTINOS_ERROR = "get/destinos/error"

export const CREATE_DESTINOS_LOADING = "create/destinos/loading"
export const CREATE_DESTINOS_SUCCESS = "create/destinos/success"
export const CREATE_DESTINOS_ERROR = "create/destinos/error"

export const UPDATE_DESTINOS_LOADING = "update/destinos/loading"
export const UPDATE_DESTINOS_SUCCESS = "update/destinos/success"
export const UPDATE_DESTINOS_ERROR = "update/destinos/error"

export const DELETE_DESTINOS_LOADING = "delete/destinos/loading"
export const DELETE_DESTINOS_SUCCESS = "delete/destinos/success"
export const DELETE_DESTINOS_ERROR = "delete/destinos/error"